<template>
  <div :class="getCss('wrap')" :style="styles.base">
    <div :class="getCss('s-tips')">
      <div :class="getCss('left')" v-if="this.isLogin">
            <span>
              <img
                :src="avatar"
                alt=""
              />
            </span>
        <p v-if="isRoleReady" :style="roleTextFontStyle">
          {{roleName}}<em></em>{{device}}-{{partitionName}}
        </p>
        <p v-if="!isRoleReady"
           :style="noRoleTextFontStyle"
           @click="handleBindRole">请先绑定游戏角色</p>
      </div>

      <div :class="getCss('left-no-login')" v-if="!this.isLogin">
            <span>
              <img
                src="https://game.gtimg.cn/images/tgclub/act/a20220829GameActivity/images1/0922img03.png"
                alt=""
              />
            </span>
        <p
          :style="noRoleTextFontStyle"
        ><a id="ptLoginBtn" v-if="!isWX" @click="loginByQQ">QQ登录</a></p>
        <p
          :class="getCss('login-wx')"
          :style="noRoleTextFontStyle"
        ><a id="wxloginBtn" v-if="isWX || isSafari" @click="loginByWx">微信登录</a></p>
      </div>

      <div :class="getCss('right')"
           :style="actionTextFontStyle"
           v-if="this.isLogin" >
        <span @click="handleBindRole" v-if="this.isLogin">换绑角色</span>
        <span v-if="showLogout" @click="handleLogout">退出</span>
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, common, baseComponents } from '../../../../ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubMatchUserArea',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-m-user-area-',
    };
  },
  computed: {
    roleTextFontStyle() {
      const { color, fontFamily, fontSize, fontWeight } = this.styles.fontStyle;
      return {
        color,
        fontFamily,
        fontWeight,
        fontSize,
      };
    },
    noRoleTextFontStyle() {
      const { noRoleTextColor, fontFamily, fontSize, fontWeight } = this.styles.fontStyle;
      return {
        color: noRoleTextColor,
        fontFamily,
        fontWeight,
        fontSize,
      };
    },
    actionTextFontStyle() {
      const { actionTextColor, fontFamily, fontSize, fontWeight } = this.styles.fontStyle;
      return {
        color: actionTextColor,
        fontFamily,
        fontWeight,
        fontSize,
      };
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      console.log('isWxCookie = ', isWxCookie);
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    showRole() {
      const bushandang = this.actInfo.extendConfig.bushandang || false;
      if (bushandang) {
        return this.isRoleStatusValid;
      }
      return this?.actInfo?.extendConfig?.forceRole;
    },
    disableLogout() {
      return this.$actInfo && this.$ast.isAPP();
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    avatar() {
      return this.isLogin ? this.userInfo.avatar : 'https://game.gtimg.cn/images/js/img/lottery/default_head.png';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
    device() {
      if (this.isRoleReady) {
        return  this.roleInfo?.plat_id === 1 ? '安卓' : 'ios';
      }
      return '';
    },
    showLogout() {
      console.log('showLogout', this.$actInfo && !this.$ast.isAPP());
      return this.$actInfo && !this.$ast.isAPP();
    },
    isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    },
  },
  mounted() {
    console.log('version 1.0.10 tgclub user area  configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      // 用户登陆
      this.$eventBus.$onLogined(this.handleLogin);
      this.gameCode = this.configurationData.game_code ? this.configurationData.game_code : this.actInfo.game_code;
    },
    async loginByQQ() {
      this.login({
        loginType: 'qq',
      });
      this.handleClickEvent();
    },
    async loginByWx() {
      this.login({
        loginType: 'wx',
      });
      this.handleClickEvent();
    },
    async handleLogout() {
      this.logout();
    },

    async handleLogin() {
      // 自动绑定角色
      const { showBindRole = true } = this.configurationData;
      const bushandang = this.actInfo.extendConfig.bushandang || false;
      if (bushandang) {
        if (this.isRoleStatusValid) {
          this.checkRoleInfo({ showBindRole }).then((roleInfo) => {
            console.log('broadcastCheckRoleResult  广播是否有角色的事件 roleInfo ', roleInfo);
            this.broadcastCheckRoleResult(roleInfo);
          });
        }
      } else {
        if (this?.actInfo?.extendConfig?.forceRole) {
          this.checkRoleInfo({ showBindRole }).then((roleInfo) => {
            console.log('broadcastCheckRoleResult  广播是否有角色的事件 roleInfo ', roleInfo);
            this.broadcastCheckRoleResult(roleInfo);
          });
        }
      }
      if (this.isClientGame && this.isWX) {
        this.$confirm({
          msg: '端游仅限QQ登录',
          cancel() {
            console.log('cancel 端游仅限QQ登录');
          },
          confirm() {
            console.log('confirm 端游仅限QQ登录');
          },
        });
      }
    },
    broadcastCheckRoleResult(roleInfo) {
      this.$eventBus.$emit('ceiba:custom:events:broadcast:check:role:result', { roleInfo });
    },
    async handleBindRole() {
      try {
        console.log('user access click handleBindRole');
        baseComponents.gameRoleSelect.showGameRoleSelect(this.actInfo.game_code, {}).then((roleInfo) => {
          console.log('select role=', roleInfo);
          this.saveCurrentRole({
            isRoleReady: true,
            roleInfo,
          });
        })
          .catch((response) => {
            console.error('action bind role fail  response =', response);
          });
      } catch (err) {
        console.error('action bind role fail catch  error =', err);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

</style>
